import { Component, OnInit, Input } from '@angular/core';
import { WaHelperService } from '../../../../wa-services/wa-helper-service';

@Component({
  selector: 'lib-country-name-flag',
  templateUrl: './country-name-flag.component.html',
  styleUrls: ['./country-name-flag.component.scss'],
  providers:[WaHelperService]
})
export class CountryNameFlagComponent implements OnInit {
  @Input()
  noc:string;
  constructor() { }

  ngOnInit() {
    if(this.noc==undefined){
      throw new Error("property rankPrevious id it's not defined please bind property <lib-country-name-flag [noc]='your-data'")
    }
  }

}
